<script>
import { useAlert } from 'dashboard/composables';
import { mapActions } from 'vuex';

export default {
  name: "DeleteResidentModal",
  props: {
    condoId: {
      type: String,
      required: true,
    },
    residentId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isDeleting: false,
    };
  },
  methods: {
    ...mapActions('condoMngt', ['deleteResident']),
    useAlert,

    async handleDelete() {
      this.isDeleting = true;
      try {
        await this.deleteResident({
          condoId: this.condoId,
          residentId: this.residentId,
        });

        this.useAlert('Resident deleted successfully.');
        this.$emit('deleted');
        this.$emit('close');
      } catch (err) {
        console.error(err);
        if (Array.isArray(err)) {
          this.useAlert(err.join('\n'));
        } else {
          this.useAlert('Failed to delete resident. Please try again.');
        }
      } finally {
        this.isDeleting = false;
      }
    },
  },
};
</script>

<template>
  <div class="fixed inset-0 flex items-center justify-center bg-slate-800/80 z-50">
    <div class="bg-white dark:bg-slate-900 rounded-lg p-6 shadow-lg w-96">
      <!-- Header -->
      <div class="flex items-center mb-4 justify-between">
        <h1 class="text-xl font-bold text-slate-900 dark:text-slate-100">Delete Resident</h1>
        <woot-button variant="clear" color-scheme="alert" icon="dismiss" @click="$emit('close')" />
      </div>

      <!-- Confirmation message -->
      <div class="mb-6 text-slate-700 dark:text-slate-200">
        Are you sure you want to delete this resident? This action cannot be undone.
      </div>

      <!-- Action buttons -->
      <div class="flex justify-end gap-4 mt-4">
        <woot-button color-scheme="secondary" @click="$emit('close')">Cancel</woot-button>
        <woot-button
          :is-loading="isDeleting"
          color-scheme="alert"
          icon="delete"
          @click="handleDelete"
        >
          Delete
        </woot-button>
      </div>
    </div>
  </div>
</template>
